/**
 * Canonical primary collage is `users/{uid}.primaryCollageId` (matches a `savedWantedPosters[].id`).
 * Falls back for legacy data: private-match poster, then a community-posted poster.
 */
export function getPrimarySavedPoster(savedPosters, primaryCollageId) {
  if (!Array.isArray(savedPosters) || savedPosters.length === 0) return null;
  if (primaryCollageId) {
    const byId = savedPosters.find((p) => p.id === primaryCollageId);
    if (byId) return byId;
  }
  const withPrivate = savedPosters.find((p) => p.isPrivateCollage);
  if (withPrivate) return withPrivate;
  return savedPosters.find((p) => p.postedToFeed && p.feedAdId) || null;
}
